import Config from '../config/config';
import axios from 'axios';

const { baseURL } = Config.API;

const create = async (formData) => {
  return axios({
    method: 'POST',
    baseURL,
    url: '/users/create',
    data: formData
  });
};

const update = async (_id, formData) => {
  return axios({
    method: 'PATCH',
    baseURL,
    url: `/users/update/${_id}`,
    data: formData
  });
};

const getUsers = async (queryParams) => {
  return axios({
    method: 'GET',
    baseURL,
    url: '/users/getUsers',
    params: queryParams
  });
};

const disableUsers = async (ids) => {
  return axios({
    method: 'PATCH',
    baseURL,
    url: '/users/disableUsers',
    data: {
      userIds: ids
    }
  });
};

const enableUsers = async (ids) => {
  return axios({
    method: 'PATCH',
    baseURL,
    url: '/users/enableUsers',
    data: {
      userIds: ids
    }
  });
};

const deleteUsers = async (ids) => {
  return axios({
    method: 'DELETE',
    baseURL,
    url: '/users/deleteUsers',
    data: {
      userIds: ids
    }
  });
};

export default {
  create,
  update,
  getUsers,
  deleteUsers,
  disableUsers,
  enableUsers
};
